import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

import { ESGImpactHexBorderMap, ESGImpactHexCodesMap } from 'shared/constants/ESGImpactHexCodesMap';

const useStyles = makeStyles({
  root: {
    borderRadius: 10,
    width: 20,
    height: 10,
    background: 'red',
  },
});

export const LegendColorChip = ({ impactLevel, className }) => {
  const classes = useStyles();
  const classNames = clsx(classes.root, className);

  return (
    <div
      className={classNames}
      style={{
        backgroundColor: ESGImpactHexCodesMap[impactLevel],
        border: ESGImpactHexBorderMap[impactLevel],
      }}
    />
  );
};

LegendColorChip.defaultProps = {
  className: undefined,
};

LegendColorChip.propTypes = {
  impactLevel: PropTypes.oneOf(['insignificant', 'veryLow', 'low', 'medium', 'high', 'veryHigh'])
    .isRequired,
  className: PropTypes.string,
};
